export const CLIENT_UPDATE_MESSAGE = 'The game has been updated. Reload now to avoid errors.';

export class ClientUpdateBanner {
  readonly element = document.createElement('header');

  constructor() {
    this.element.className = 'client-update-banner';
    this.element.hidden = true;
    this.element.setAttribute('role', 'status');
    this.element.setAttribute('aria-live', 'polite');
  }

  show(): void {
    if (!this.element.hidden) return;
    const message = document.createElement('span');
    message.textContent = CLIENT_UPDATE_MESSAGE;
    const reload = document.createElement('button');
    reload.type = 'button';
    reload.textContent = 'Reload now';
    reload.addEventListener('click', () => window.location.reload());
    this.element.hidden = false;
    this.element.append(message, reload);
  }
}
